import React, { useEffect, useState } from 'react';

/** Parse wedding_date from API (YYYY-MM-DD or YYYY-MM-DD HH:MM:SS). */
function parseWeddingDate(weddingDate) {
  if (weddingDate == null || weddingDate === '') return null;
  const raw = String(weddingDate).trim();
  const datePart = raw.match(/^(\d{4}-\d{2}-\d{2})/);
  if (datePart) {
    const atNoon = new Date(`${datePart[1]}T12:00:00`);
    if (!Number.isNaN(atNoon.getTime())) return atNoon;
  }
  const parsed = new Date(raw);
  if (!Number.isNaN(parsed.getTime())) return parsed;
  return null;
}

function getParts(weddingDate) {
  const target = parseWeddingDate(weddingDate);
  if (!target) {
    return { days: 0, hours: 0, minutes: 0, seconds: 0, past: false, invalid: !weddingDate };
  }
  const endOfDay = new Date(target);
  endOfDay.setHours(23, 59, 59, 999);
  const diff = endOfDay - new Date();
  if (diff <= 0) {
    return { days: 0, hours: 0, minutes: 0, seconds: 0, past: true, invalid: false };
  }
  return {
    days: Math.floor(diff / 86400000),
    hours: Math.floor((diff % 86400000) / 3600000),
    minutes: Math.floor((diff % 3600000) / 60000),
    seconds: Math.floor((diff % 60000) / 1000),
    past: false,
    invalid: false,
  };
}

const CountdownTimer = ({ weddingDate }) => {
  const [parts, setParts] = useState(() => getParts(weddingDate));

  useEffect(() => {
    setParts(getParts(weddingDate));
    const id = setInterval(() => setParts(getParts(weddingDate)), 1000);
    return () => clearInterval(id);
  }, [weddingDate]);

  if (!weddingDate) {
    return <p className="countdown-empty">Wedding date coming soon</p>;
  }

  if (parts.invalid) {
    return <p className="countdown-empty">Unable to read wedding date — check admin settings</p>;
  }

  if (parts.past) {
    return (
      <div className="countdown-celebration">
        <span className="countdown-celebration-label">The celebration has begun</span>
      </div>
    );
  }

  const units = [
    ['Days', parts.days],
    ['Hours', parts.hours],
    ['Minutes', parts.minutes],
    ['Seconds', parts.seconds],
  ];

  return (
    <div className="countdown-timer" aria-live="polite">
      {units.map(([label, val]) => (
        <div key={label} className="countdown-unit">
          <span className="number">{String(val).padStart(2, '0')}</span>
          <span className="label">{label}</span>
        </div>
      ))}
    </div>
  );
};

export default CountdownTimer;
